$(function() {
  // ==================================================
  // Form Validation
  // ==================================================
  $(document).on('paste','input[name="email_confirm"]',function(){ return false; });

  // お問い合わせ（医療機関・企業・団体の方）
  $('#form').validate({
    rules: {
      company: {
        required: true
      },
      last_name: {
        required: true,
      },
      state: {
        required: true
      },
      city: {
        required: true
      },
      street: {
        required: true
      },
      phone: {
        required: true,
        number: true
      },
      email: {
        required: true,
        email: true
      },
      email_confirm: {
        equalTo: '[name="email"]',
        required: true,
        email: true
      },
      "00N7F00000Q31OO": {
        required: true
      },
      privacy: {
        required: true
      },
    },
    messages: {
      company: {
        required: '必須項目です。入力してください。'
      },
      last_name: {
        required: '必須項目です。入力してください。',
      },
      state: {
        required: '必須項目です。入力してください。'
      },
      city: {
        required: '必須項目です。入力してください。'
      },
      street: {
        required: '必須項目です。入力してください。'
      },
      phone: {
        required: '必須項目です。入力してください。',
        number: '数字のみで入力してください。※ハイフンは不要です。'
      },
      email: {
        required: '必須項目です。入力してください。',
        email: 'メールアドレスの形式が正しくありません。'
      },
      email_confirm: {
        equalTo: '上と同じメールアドレスを入力してください。',
        required: '必須項目です。入力してください。',
        email: 'メールアドレスの形式が正しくありません。'
      },
      "00N7F00000Q31OO": {
        required: '必須項目です。選択してください。'
      },
      privacy: {
        required: 'プライバシーポリシーに同意してください。'
      }
    },
    errorClass: 'js_validation-error',
    errorElement: 'p',
    errorPlacement: function(error, element) {
      if ($(element).val() == 'privacy') {
        error.insertAfter(element.parent());
      } else {
        error.insertAfter(element);
      }
    }
  });

  // お問い合わせフォーム（個人の方）
  $('#form_personal').validate({
    rules: {
      name: {
        required: true,
      },
      email: {
        required: true,
        email: true
      },
      // email_confirm: {
      //   equalTo: '[name="email"]',
      //   required: true,
      //   email: true
      // },
      description: {
        required: true
      },
      privacy: {
        required: true
      },
    },
    messages: {
      name: {
        required: '必須項目です。入力してください。',
      },
      email: {
        required: '必須項目です。入力してください。',
        email: 'メールアドレスの形式が正しくありません。'
      },
      // email_confirm: {
      //   equalTo: '上と同じメールアドレスを入力してください。',
      //   required: '必須項目です。入力してください。',
      //   email: 'メールアドレスの形式が正しくありません。'
      // },
      description: {
        required: '必須項目です。入力してください。'
      },
      privacy: {
        required: 'プライバシーポリシーに同意してください。'
      }
    },
    errorClass: 'js_validation-error',
    errorElement: 'p',
    errorPlacement: function(error, element) {
      if ($(element).val() == 'privacy') {
        error.insertAfter(element.parent());
      } else {
        error.insertAfter(element);
      }
    }
  });

  // 販促ツールお申し込み
  $('#form_promotion').validate({
    rules: {
      company: {
        required: true,
      },
      name: {
        required: true,
      },
      "00N7F00000SfMPh": {
        required: true,
        number: true
      },
      "00N7F00000SfMPm": {
        required: true,
      },
      phone: {
        required: true,
        number: true
      },
      email: {
        required: true,
        email: true
      },
      // email_confirm: {
      //   equalTo: '[name="email"]',
      //   required: true,
      //   email: true
      // },
      "00N7F00000TsgKh": {
        require_from_group: [1, '.js_validation_group-leaflet']
      },
      "00N7F00000TsgKm": {
        require_from_group: [1, '.js_validation_group-leaflet']
      },
      "00N7F00000TsgKr": {
        require_from_group: [1, '.js_validation_group-leaflet']
      },
      "00N7F00000TsgKw": {
        require_from_group: [1, '.js_validation_group-leaflet']
      },
      "00N7F00000SfGds": {
        require_from_group: [1, '.js_validation_group-leaflet']
      },
      privacy: {
        required: true
      },
    },
    messages: {
      company: {
        required: '必須項目です。入力してください。',
      },
      name: {
        required: '必須項目です。入力してください。',
      },
      "00N7F00000SfMPh": {
        required: '必須項目です。入力してください。',
        number: '数字のみで入力してください。※ハイフンは不要です。'
      },
      "00N7F00000SfMPm": {
        required: '必須項目です。入力してください。',
      },
      phone: {
        required: '必須項目です。入力してください。',
        number: '数字のみで入力してください。※ハイフンは不要です。'
      },
      email: {
        required: '必須項目です。入力してください。',
        email: 'メールアドレスの形式が正しくありません。'
      },
      // email_confirm: {
      //   equalTo: '上と同じメールアドレスを入力してください。',
      //   required: '必須項目です。入力してください。',
      //   email: 'メールアドレスの形式が正しくありません。'
      // },
      "00N7F00000TsgKh": {
        require_from_group: '販促ツールは1つ以上必要部数を選択してください。'
      },
      "00N7F00000TsgKm": {
        require_from_group: '販促ツールは1つ以上必要部数を選択してください。'
      },
      "00N7F00000TsgKr": {
        require_from_group: '販促ツールは1つ以上必要部数を選択してください。'
      },
      "00N7F00000TsgKw": {
        require_from_group: '販促ツールは1つ以上必要部数を選択してください。'
      },
      "00N7F00000SfGds": {
        require_from_group: '販促ツールは1つ以上必要部数を選択してください。'
      },
      privacy: {
        required: 'プライバシーポリシーに同意してください。'
      }
    },
    // groups: {
    //   "js_validation_group-leaflety": '00N7F00000TsgKh 00N7F00000TsgKm 00N7F00000TsgKr 00N7F00000TsgKw 00N7F00000SfGds'
    // },
    errorClass: 'js_validation-error',
    errorElement: 'p',
    errorPlacement: function(error, element) {
      if ($(element).val() == 'privacy') {
        error.insertAfter(element.parent());
      } else {
        error.insertAfter(element);
      }
    }
  });
});